/**
 * Who a Safe Space message should be attributed to, from the pupil's side of the thread.
 *
 * A staff reply is stored with studentId 0, but the column is nullable and BigQuery — the source of
 * truth for message text — returns NULL rather than 0 for a row that never had one. The check here
 * was `studentId !== 0`, which sends a NULL row down the pupil branch and renders "Message sent by
 * undefined" against a message the pupil did not write. A falsy check covers both.
 *
 * The names have fallbacks for the same reason: a staff member whose Safe Space role has since been
 * removed no longer resolves to a name, and "Reply sent by undefined" is worse for a child to read
 * than "Reply sent by Staff".
 */
export const messageSenderLabel = (message) => {
  const isFromStaff = !message?.studentId;

  if (isFromStaff) {
    return `Reply sent by ${message?.responderName || 'Staff'}`;
  }

  return `Message sent by ${message?.studentName || 'You'}`;
};

export default messageSenderLabel;
